import React from "react";

const InfoIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 20C7.584 20 4 16.416 4 12C4 7.584 7.584 4 12 4C16.416 4 20 7.584 20 12C20 16.416 16.416 20 12 20ZM12.7999 7.99998H11.1999V12.8H12.7999V7.99998ZM12.7999 14.4H11.1999V16H12.7999V14.4Z" fill="white" />
    </svg>
  )
}

export default InfoIcon;
